import { useState } from 'react';

/**
 * A hook to safely manage nested forms and prevent infinite nesting.
 * 
 * @param {number} maxDepth - Maximum nesting depth allowed (default = 2)
 * @param {number} currentDepth - Current depth level (default = 0)
 * @returns {object}
 */
export function useNestedForm(maxDepth = 2, currentDepth = 0) {
  const [showForm, setShowForm] = useState(null);

  /**
   * Opens the nested form for a given target
   * if nesting is allowed based on maxDepth.
   */
  const openForm = (target) => {
    if (currentDepth < maxDepth) {
      setTimeout(() => setShowForm(target), 0);
    } else {
      console.warn(`[useNestedForm] Max nesting depth (${maxDepth}) reached.`);
    }
  };

  /**
   * Closes the currently shown nested form.
   */
  const closeForm = () => setShowForm(null);

  return {
    showForm,        // string | null — current target
    openForm,        // function — call to open a form
    closeForm,       // function — call to close
    canNest: currentDepth < maxDepth,
    nextDepth: currentDepth + 1
  };
}
